import React from 'react'
import PropTypes from 'prop-types'
import Hero from './Hero'

const HeroBackgroundImage = props => {
  const {
    content: { heading, content, backgroundImage, facetImage, mobileBgImage },
  } = props

  return (
    <Hero
      heading={heading}
      content={content}
      backgroundImageArray={backgroundImage}
      facetImage={facetImage}
      mobileBgImageArray={mobileBgImage}
    />
  )
}

HeroBackgroundImage.defaultProps = {
  content: {
    contentIdentifier: '',
    heading: '',
    content: {},
    backgroundImage: [],
    facetImage: {},
    mobileBgImage: [],
  },
}

HeroBackgroundImage.propTypes = {
  content: PropTypes.object,
}

export default HeroBackgroundImage
